<template>
  <div class="process-container">
    <v-list color="transparent" nav>
      <v-list-item
        :disabled="!step.button.clickable"
        v-for="(step, i) in steps"
        :key="i"
      >
        <v-list-item-content class="item-text">
          <v-stepper non-linear flat v-model="highlightedStep" vertical>
            <v-stepper-step
              color="#35887E"
              :complete="highlightedStep > i + 1"
              :step="i + 1"
              :complete-icon="String(i + 1)"
            >
              {{ step.text }}
            </v-stepper-step>
          </v-stepper>
        </v-list-item-content>
        <v-list-item-action class="item-action">
          <!-- the @click in the button bellow is just an example on using the stepper -->
          <!-- add :rules="[() => false]" in the v-btn, for error theme -->
          <v-btn
            :disabled="!step.button.clickable"
            outlined
            v-text="step.button.text"
            @click="submitAnswer(i)"
          ></v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <!-- UNCOMMENT BUTTON AS NOT NECESSARY <v-btn depressed class="primary-txt-btn">Weiter zur ersten Frage</v-btn>  -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      highlightedStep: 2,
      steps: [
        {
          text: "Passende Produkte wählen",
          highlighted: true,
          button: {
            clickable: true,
            text: "Starten",
            inputInterpretationContext: {
              variableName: "desiredProcessProduct",
              evaluationLogic: "buttonToBoolTrue",
            },
          },
        },
        {
          text: "Passende Sanitätshäuser finden",
          highlighted: false,
          button: {
            clickable: true,
            text: "Erfolgt später",
            inputInterpretationContext: {
              variableName: "desiredProcessShop",
              evaluationLogic: "buttonToBoolTrue",
            },
          },
        },
        {
          text: "Kostenübernahme beantragen Produkte wählen",
          highlighted: false,
          button: {
            clickable: false,
            text: "Erfolgt später",
            inputInterpretationContext: {
              variableName: "desiredProcessCost",
              evaluationLogic: "buttonToBoolTrue",
            },
          },
        },
      ],
    };
  },
  methods: {
    submitAnswer(indexStartingWith0) {
      let newInput = {
        "button": {
            "clicked": true,
            "indexOfClickedButtonInProcessCard": indexStartingWith0
        }
      };
      this.$emit("submitAnswer", newInput);
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Process Card");
      this.steps = executableSystemAction.guiTemplateContent.steps;
      this.highlightedStep = executableSystemAction.guiTemplateContent.highlightedStep;
    }
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate");
    });
  },
};
</script>

<style></style>
